import instaplayAPI from '../../services/api/instaplays'

const state = () => {
    return {
        thumbs: {},
        count: 0
    }
}

const actions = {
    async getThumbnails ({ state, commit, rootState }, userList) {
        let newUsers = []
        for (let user of userList) {
            if (state.thumbs[user] === undefined) {
                newUsers.push(user)
                state.thumbs[user] = ''
            }
        }
        if (!newUsers.length) return

        const payload = {
            useridlist: '['+newUsers.toString()+']',
            token: rootState.auth.user.token
        }

        let response
        try {
            response = await instaplayAPI.getThumbnails(payload)
        } catch (e) {
            commit('cleanEmpty', newUsers)
            return
        }
        if (response.Success) {
            commit('setThumbs', response.photo)
            commit('cleanEmpty', newUsers)
        }

    },
    findThumbs({commit}, {objList, id = 'userid', thumb = 'photo'}) {
        let thumbs = []
        for (let obj of objList) {
            if (obj[thumb] && obj[thumb] !== 'null')
                thumbs[obj[id]] = obj[thumb]
        }
        commit('setThumbs', thumbs)
    }
}

const mutations = {
    setThumbs (state, thumbs) {
        // Object.assign(state.thumbs, thumbs)
        state.thumbs = {...state.thumbs, ...thumbs}
        state.count += Object.keys(thumbs).length
    },
    cleanEmpty (state, list) {
        for (let id of list)
            if (state.thumbs[id] === '')
                delete state.thumbs[id]
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
